<template>
  <div class="tab config-tab panel-layout-config-tab">
    <Background :background="options.background" @change="propChangedForAllViews('background', $event)" />
    <Divider />

    <Alignment :label="$t('content-align')" :options="options.align" @change="propChanged('align', $event)" />
    <Divider />

    <Spacement
      :negative="true"
      :label="margin"
      :options="options.margin"
      @change="propChanged(`margin.${$event.field}`, $event.value)"
    />
    <Divider />

    <Spacement
      :label="padding"
      :options="options.padding"
      @change="propChanged(`padding.${$event.field}`, $event.value)"
    />
  </div>
</template>

<script>
import LayoutMixin from '@/components/sidenav/landing/shared/LayoutMixin.js'
import { mapGetters } from 'vuex'
import WidgetTranslateMap from '@/mixins/WidgetTranslateMap'

export default {
  name: 'PanelSideNavLayoutTab',
  mixins: [LayoutMixin, WidgetTranslateMap],
  i18nOptions: { keyPrefix: 'components.sidenav.landing.panel.layout.margin' },
  computed: {
    ...mapGetters('landing', ['widget']),
    widgetMapText() {
      return this.$options.containerTextWidgetTranslateMap['widget/Text']
    },
    margin() {
      return `${this.$t('margin')} ${this.$t(this.widgetMapText)}`
    },
    padding() {
      return `${this.$t('padding')} ${this.$t(this.widgetMapText)}`
    },
  },
}
</script>

<style lang="scss" scoped>
.config-tab {
  padding-bottom: 20px;
  .advanced-collapsible {
    margin: 10px -10px 0;
    padding: 0 !important;
  }
}

.panel-layout-config-tab {
  background-color: white;
}
</style>
